import { useEffect, useRef } from 'react';
import { useAbortableFetch } from '../../../hooks/useAbortableFetch';
import { abortableFetch } from '../../../utils';
import {
  bindFetchToRef,
  useApiState,
} from '../../../components/Hooks/useApiState';
import { useDispatch } from 'react-redux';
import { useNotifications } from '../../../components/Notification/useNotifications';
import { useViewId } from '../../CreativeAnalytics/selectors';
import { usePlatform } from '../../CreativeAnalytics/CategoryBuilder/selectors';

const UPLOAD_ASSET_ENDPOINT = [
  'api',
  'creative-analytics',
  'report-builder',
  'upload-asset',
].join('/');

export const useUploadAssetApi = () => {
  const { data, loading, error, request } = useAbortableFetch();

  const uploadAsset = ({
    account_id,
    platform,
    ad_id,
    user_id,
    s3_url,
    visual_type,
  }) => {
    request(UPLOAD_ASSET_ENDPOINT, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        account_id,
        platform,
        ad_id,
        user_id,
        s3_url,
        visual_type,
      }),
    });
  };

  return { data, loading, error, uploadAsset };
};

export function uploadReportBuilderAsset(payload) {
  console.log(payload);
  return abortableFetch(
    [
      'api',
      'creative-analytics',
      'report-builder',
      payload.viewId,
      'report-builder-asset-upload',
    ].join('/'),
    {
      method: 'POST',
      body: payload.file,
      credentials: 'include',
    }
  );
}

export const useUploadReportBuilderAssetApi = () => {
  const view_id = useViewId();
  const platform = usePlatform();
  const mounted = useRef(false);
  const withRef = bindFetchToRef(mounted);
  const dispatch = useDispatch();
  const notifications = useNotifications();
  const [postState, postDispatch] = useApiState(
    (payload) =>
      withRef(uploadReportBuilderAsset(payload)).then((data) => {
        console.log(data);
        return data;
      }),
    {
      loading: false,
      error: null,
      data: null,
      count: 0,
    }
  );

  useEffect(() => {
    mounted.current = true;

    return () => (mounted.current = false);
  }, []);

  useEffect(() => {
    if (postState.data) {
      console.log(postState.data);
      notifications.remove('asset-uploading');
      notifications.add({
        id: `asset-upload-success`,
        title: 'Asset uploaded',
        message: 'Please wait',
        showEllipses: true,
      });
      // assetPredictionStatusApi.fetch();
    }
  }, [postState.data]);

  useEffect(() => {
    if (postState.loading) {
      notifications.add({
        id: `asset-uploading`,
        title: 'Uploading asset',
        message: 'Please wait',
        showEllipses: true,
      });
    }
  }, [postState.loading]);

  useEffect(() => {
    if (postState.error) {
      try {
        notifyError(
          'There was an error.',
          postState.error.error.message.toString()
        );
      } catch (error) {
        console.error(error);
        notifyError('There was an error.', postState.error.toString());
      }
    }
  }, [postState.error]);

  const upload = async (files, fileName) => {
    if (!files[0]) return console.error('Unable to upload file.');
    const formData = makeFormData(files[0], fileName);
    for (const value of formData.values()) {
      console.log(value);
    }

    console.log({
      file: makeFormData(files[0]),
    });

    const { s3_filename, s3_url, versionId } = await fetch(
      [
        'api',
        'creative-analytics',
        view_id,
        platform,
        'report-builder-asset-upload',
      ].join('/'),
      {
        credentials: 'include',
        method: 'POST',
        body: formData,
      }
    ).then((r) => r.json());

    console.log({ s3_filename, s3_url, versionId });

    return { s3_filename, s3_url, versionId };

    // postDispatch({
    //   viewId,
    //   file: makeFormData(files[0], viewId, platform),
    // });
  };

  return {
    upload,
    ...postState,
  };
};

const makeFormData = (file, fileName) => {
  const data = new FormData();

  // data.append('view_id', view_id);
  // data.append('platform', platform);
  data.append('created', file.lastModified);
  data.append('filename', fileName);
  data.append('type', file.type);
  data.append('file', file);

  return data;
};

export const notifyError = (name, error) => {
  const notifications = useNotifications();

  notifications.add({
    title: name,
    message: error,
    toastProps: {
      className: 'error-toast',
    },
  });
};
